export default __webpack_public_path__ + "static/media/c2450b02a705b7f69066cb3d26f48b12b17e29018c5dc4d902451b278dc8187a.7cef63ee.png";